import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Spinner from '../Utils/Spinner';
import Header from '../Main/Header';
import Episodes from './Episodes';

const WatchSeason = () => {
    const params = useParams();
    const season = params.season;

    const [searchParams, setSearchParams] = useSearchParams();

    const [error, setError] = useState();
    const navigate = useNavigate();

   

    return (
        <>
            <div className='h-screen relative'>
                <Header />

                    <>
                        <div className='absolute -z-20 right-0 top-0 h-full w-full'>
                            {/* <img
                            className='h-full w-full object-cover'
                            src={`https://image.tmdb.org/t/p/w500${data.backdrop_path}`}
                            alt=''
                        /> */}
                        </div>

                        <div className='absolute top-0 -z-10 right-0 h-full w-full bg-black opacity-80'></div>
                        <div className='h-5/6 w-screen overflow-y-scroll'>
                            <div className='h-5'></div>
                            <div className='text-white text-xl text-center p-2'>{searchParams.get('title')}</div>
                        <div className='text-white text-xs text-center p-2'>(Season { params.season})</div>
                            <br />

                            <Episodes />

                            <div className='h-14'></div>
                        </div>
                    </>
                
               
            </div>
        </>
    );
};

export default WatchSeason;
